import { Component } from "react"
//
import PropTypes from "prop-types"

import { createOrderByFilterGroup, genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import {
    BulkEmailNumberOpensFilter,
    BulkEmailNumberClicksFilter,
} from "shared/search/containers/Filter/BulkEmailFilters"

import { createDateListFilter, DateListNoFutureFilter } from "shared/search/containers/Filter/Filters"

import { GrassrootsActionCampaignFilter } from "shared/search/containers/Filter/GrassrootsActionFilters"

import {
    SendEmailBulkEmailFilter,
    SendEmailToTypeFilter,
    SendEmailOfficialFilter,
    SendEmailStafferFilter,
    SendEmailPressContactFilter,
    SendEmailContactFilter,
    SendEmailCreatedDatePickerStartNoFutureFilter,
    SendEmailCreatedDatePickerEndNoFutureFilter,
    SendEmailReceivedFilter,
    SendEmailOpenedFilter,
    SendEmailClickedFilter,
    SendEmailRepliedFilter,
    SendEmailOfficialsAndStaffersFilter,
    SendEmailEmailAddressFilter,
    SendEmailRecipientNameFilter,
    ClickedLinkFilter,
} from "shared/search/containers/Filter/SendEmailFilters"

export const SendEmailBulkEmailFilterGroup = (props) => genericFilterGroup(props)
SendEmailBulkEmailFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
SendEmailBulkEmailFilterGroup.defaultProps = {
    filters: [SendEmailBulkEmailFilter, SendEmailToTypeFilter, BulkEmailNumberOpensFilter, BulkEmailNumberClicksFilter],
    uniqueFilterGroupId: "sendEmailBulkEmailFilterGroup",
    displayLabel: "Outbox Email",
    helpText: "Filter recipient emails by their corresponding outbox email",
}

export const SendEmailRecipientFilterGroup = (props) => genericFilterGroup(props)
SendEmailRecipientFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
SendEmailRecipientFilterGroup.defaultProps = {
    filters: [
        SendEmailOfficialFilter,
        SendEmailStafferFilter,
        SendEmailOfficialsAndStaffersFilter,
        SendEmailPressContactFilter,
        SendEmailContactFilter,

        SendEmailEmailAddressFilter,
        SendEmailRecipientNameFilter,
    ],
    uniqueFilterGroupId: "sendEmailRecipientFilterGroup",
    displayLabel: "Recipient",
    helpText: "Filter recipient emails by information related to their recipient",
}

export const SendEmailStatusFilterGroup = (props) => genericFilterGroup(props)
SendEmailStatusFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
SendEmailStatusFilterGroup.defaultProps = {
    filters: [SendEmailReceivedFilter, SendEmailOpenedFilter, SendEmailClickedFilter, SendEmailRepliedFilter],
    uniqueFilterGroupId: "sendEmailStatusFilterGroup",
    displayLabel: "Status",
    helpText: "Filter recipient emails by their current interaction status",
}

export const SendEmailDateFilterGroup = (props) => genericFilterGroup(props)
SendEmailDateFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
SendEmailDateFilterGroup.defaultProps = {
    filters: [
        createDateListFilter(
            DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
                (item) =>
                    ![
                        DjangIO.app.events.models.DateRangeType.future.value,
                        DjangIO.app.events.models.DateRangeType.next_month.value,
                        DjangIO.app.events.models.DateRangeType.next_week.value,
                        DjangIO.app.events.models.DateRangeType.this_year.value,
                    ].includes(item.value),
            ),
        ),
        SendEmailCreatedDatePickerStartNoFutureFilter,
        SendEmailCreatedDatePickerEndNoFutureFilter,
    ],
    uniqueFilterGroupId: "sendEmailDateFilterGroup",
    displayLabel: "Date",
    helpText: "Filter recipient emails by their date sent",
}

export const ClickedLinkFilterFilterGroup = (props) => genericFilterGroup(props)
ClickedLinkFilterFilterGroup.defaultProps = {
    filters: [ClickedLinkFilter],
    uniqueFilterGroupId: "clickedLinkFilterFilterGroup",
    invisible: true,
}

export class SendEmailCampaignFilterGroup extends Component {
    static defaultProps = {
        filters: [GrassrootsActionCampaignFilter],
        uniqueFilterGroupId: "sendEmailCampaignFilterGroup",
        displayLabel: "Campaign",
        helpText: "Filter actions by your grassroots campaigns.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
export const SendEmailOrderByFilterGroup = createOrderByFilterGroup({
    // uniqueFilterId = "send_emailOrderBy"
    quorumDataType: DjangIO.app.models.QuorumDataType.send_email.value,
})

export const SendSMSOrderByFilterGroup = createOrderByFilterGroup({
    //uniqueFilterId: "send_emailOrderBy",
    quorumDataType: DjangIO.app.models.QuorumDataType.send_sms.value,
})
